module.exports = __webpack_public_path__ + "media/flags/ly-02815876.svg";